module.exports = __webpack_public_path__ + "static/img/日喀则市.f7c033bf.jpg";